import { store } from '../../../store'
import { MessageDataType } from '../types'
import { incrementalNotificationAction } from '../../../store/app/actions/notificationActions'
import {
  Notification,
  NotificationStatus,
  NotificationType,
} from '../../../api/v1/message'
import toastify from '../../../components/Toastify'

export interface WsNotificationData {
  type: 'account_message'
  sequenceId: number
  timestamp: number
  userId: number
  data: Notification
}

export function onMessageNotification(data: MessageDataType) {
  switch (data.type) {
    // Receive new notification data, used to display in the 'Notification' component
    case 'account_message':
      updateNotification(data as WsNotificationData)
      break
  }
}

function updateNotification(message: WsNotificationData) {
  const { data } = message
  const { messageType, messageStatus, content } = data
  store.dispatch(incrementalNotificationAction([data]))

  const { fundChange } = store.getState().settings.preferences

  if (messageType === NotificationType.FUND_CHANGE && fundChange) {
    if (messageStatus === NotificationStatus.Successful) {
      toastify.success(content)
    } else if (messageStatus === NotificationStatus.Failed) {
      toastify.error(content)
    } else {
      toastify.info(content)
    }
  }
}
